import { toTimestampMs } from '@/shared/lib';

import type { PatientNavigatorItemData } from './types';

export type DateSortOrder = 'asc' | 'desc';

function getOldestRequestAtMs(patient: PatientNavigatorItemData): number | null {
  return toTimestampMs(patient.oldestRequestAt);
}

function compareOldestRequestAtAsc(
  a: PatientNavigatorItemData,
  b: PatientNavigatorItemData
): number {
  const aOldestMs = getOldestRequestAtMs(a);
  const bOldestMs = getOldestRequestAtMs(b);

  if (aOldestMs !== null && bOldestMs !== null && aOldestMs !== bOldestMs) {
    return aOldestMs - bOldestMs;
  }
  if (aOldestMs === null && bOldestMs !== null) {
    return 1;
  }
  if (aOldestMs !== null && bOldestMs === null) {
    return -1;
  }

  return 0;
}

function compareOldestRequestAtDesc(
  a: PatientNavigatorItemData,
  b: PatientNavigatorItemData
): number {
  const aOldestMs = getOldestRequestAtMs(a);
  const bOldestMs = getOldestRequestAtMs(b);

  if (aOldestMs !== null && bOldestMs !== null && aOldestMs !== bOldestMs) {
    return bOldestMs - aOldestMs;
  }
  if (aOldestMs === null && bOldestMs !== null) {
    return 1;
  }
  if (aOldestMs !== null && bOldestMs === null) {
    return -1;
  }

  return 0;
}

function compareByOldestAscOnly(a: PatientNavigatorItemData, b: PatientNavigatorItemData): number {
  const oldestDiff = compareOldestRequestAtAsc(a, b);
  if (oldestDiff !== 0) {
    return oldestDiff;
  }
  return a.fullName.localeCompare(b.fullName);
}

function compareByOldestDescOnly(a: PatientNavigatorItemData, b: PatientNavigatorItemData): number {
  const oldestDiff = compareOldestRequestAtDesc(a, b);
  if (oldestDiff !== 0) {
    return oldestDiff;
  }
  return a.fullName.localeCompare(b.fullName);
}

export function getPatientNavigatorComparator(
  dateSortOrder: DateSortOrder
): (a: PatientNavigatorItemData, b: PatientNavigatorItemData) => number {
  switch (dateSortOrder) {
    case 'asc':
      return compareByOldestAscOnly;
    case 'desc':
      return compareByOldestDescOnly;
    default: {
      const exhaustiveCheck: never = dateSortOrder;
      return exhaustiveCheck;
    }
  }
}
